import { render, staticRenderFns } from "./AcoesDaGridDePedidos.vue?vue&type=template&id=5f672736&scoped=true&"
import script from "./AcoesDaGridDePedidos.vue?vue&type=script&lang=ts&"
export * from "./AcoesDaGridDePedidos.vue?vue&type=script&lang=ts&"
import style0 from "./AcoesDaGridDePedidos.vue?vue&type=style&index=0&id=5f672736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f672736",
  null
  
)

export default component.exports